import React from 'react'
import { PHONE_CODE } from '../../../configs/phoneCode.config'

const Register = (locals) => {
  const hasError = locals.hasError === true ? 'has-error' : ''
  const msg = locals.error ? <span className="help-block error-block">{locals.error}</span> : ''
  const label = locals.label ? locals.label : locals.attrs.name

  return (
    <div className={`eform-input eform-input-${locals.attrs.name} ${hasError} row`}>
      <div className="eform-label col-12 col-lg-4 nopadding">{label} <span>:</span></div>
      <div className="eform-desc col-12 col-lg-8 nopadding">
        <div className="eform-desc-inner">
          <select className="eform-input-item form-control placeholder-no-fix" style={{ width: '22.5%', float: 'left' }} defaultValue="+84" name="prefixPhone">
            {
              PHONE_CODE.map((item) => {
                return (
                  <option key={item.code.toString()} value={item.code}>{item.code}</option>
                )
              })
            }
          </select>
          <input
            style={{ width: '75.5%', float: 'right' }}
            className="eform-input-item form-control placeholder-no-fix"
            autoComplete="off"
            value={locals.value}
            onChange={event => locals.onChange(event.target.value)}
            {...locals.attrs}
          />
        </div>
        {msg}
      </div>
      <div className="clearfix" />
    </div>
  )
}

export default Register
